export const MESSAGE = {
	ERROR: {
		NETWORK: '네트워크 오류가 발생했습니다. 잠시 후 다시 시도해주세요',
		UNKNOWN: '알 수 없는 오류가 발생했어요',
		RETRY: '잠시 후 다시 시도해주세요',
		USER_NOT_FOUND: '사용자 정보를 찾을 수 없어요',
		LOGIN_FAILED: '로그인에 실패했어요',
		LOGOUT_FAILED: '로그아웃에 실패했습니다. 다시 시도해주세요',
		ACCOUNT_DELETE_FAILED: '계정 삭제에 실패했어요',
		NICKNAME_CHANGE_FAILED: '닉네임 변경에 실패했어요',
		STATION_INFO_FAILED: '주유소 정보를 불러올 수 없어요',
		STATION_INFO_LOADING: '주유소 정보를 불러오고 있어요.',
		NO_FUEL_EFFICIENCY: '연비 데이터가 없습니다',
	},
	SUCCESS: {
		LOGIN: '로그인이 완료되었어요',
		LOGOUT: '로그아웃이 완료되었어요',
		NICKNAME_CHANGED: '닉네임이 변경되었어요',
		ACCOUNT_DELETED: '계정이 삭제되었어요',
		FAVORITE_ADDED: '즐겨찾기에 추가했어요',
		FAVORITE_REMOVED: '즐겨찾기에서 제거했어요',
		CAR_REGISTERED: '차량이 등록되었어요',
		CAR_UPDATED: '차량 정보가 수정되었어요',
	},
	RECOMMENDATION: {
		SAVINGS_CALCULATION_BASIS_WITH_FUEL_EFFICIENCY: (
			fuelEfficiency: number,
			fuelAmount: number,
		) => `연비 ${fuelEfficiency}km/L · 주유량 ${fuelAmount}L 기준`,
		SAVINGS_CALCULATION_BASIS_WITHOUT_FUEL_EFFICIENCY: (fuelAmount: number) =>
			`차량 연비를 등록하면 주유량 ${fuelAmount}L 기준으로 계산돼요`,
	},
} as const;

export const UNIT = {
	KILOMETER_PER_LITER: 'km/L',
} as const;
